// IMPORT
const THREE = require('three')


import * as text from './text-simple'
import * as cta from './cta'
import * as scrollCta from './scrollCta'
import * as countdown from './countdown'
import * as distance from './distance'
import * as eyelid from './eyelid'

import dashboard from './dashboard'



// INIT
export let scene = new THREE.Scene()
export default scene

// TEXT
scene.add(text.mesh)
// text.mesh.position.y = 140

// // CTA
scene.add(cta.mesh)
cta.mesh.position.y = -window.innerHeight * 0.22

// // SCROLL CTA
scene.add(scrollCta.mesh)
// scrollCta.mesh.position.y = -window.innerHeight * 0.2

// COUNTDOWN
scene.add(countdown.mesh)

// EYE LID
scene.add(eyelid.mesh)

// DISTANCE
// scene.add(distance.mesh)

// DASHBOARD
export const showDashboard = function () {
  scene.add(dashboard.mesh)
  dashboard.startStage1()
}

export const hideDashboard = function () {
  scene.remove(dashboard.mesh)
}


// WEBPACK FOOTER //
// ./src/components/game/ui/scene.js